module.exports = __webpack_public_path__ + "static/3A841E_3_0-856f83a8e92867462764c1d4aa4f60cd.ttf";